import React, { useState } from "react";
import OneOverlayLoader from "../../../../utils/component-utils/OverlayLoader/OneOverlayLoader";
import { IonLoading } from "@ionic/react";
interface RenderIframeProps {
  src: string;
  title: string;
  width: string;
  height: string;
  sandboxItems: string;
  allowFullScreen: boolean;
  frameBorder: string;
}
const RenderIframe: React.FC<RenderIframeProps> = ({
  src,
  title,
  width,
  height,
  sandboxItems,
  allowFullScreen,
  frameBorder,
}) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };
  return (
    <React.Fragment>
      <IonLoading
        message="Loading QuikStrike..."
        isOpen={!iframeLoaded}
      ></IonLoading>
      <iframe
        id="frame"
        src={src}
        title={title}
        width={width}
        height={height}
        sandbox={`${sandboxItems}`}
        allowFullScreen={allowFullScreen}
        frameBorder={frameBorder}
        loading="lazy"
        onLoad={handleIframeLoad}
      ></iframe>
    </React.Fragment>
  );
};

export default RenderIframe;
